import { types } from './actions';


const initialState = {
  viewMissing: true,
  viewNotExpected: false,
  selectedMissingTicketNumberId: null,
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VIEW_MISSING: {
      return {
        ...state,
        viewMissing: true,
        viewNotExpected: false,
        selectedMissingTicketNumberId: null,
      };
    }
    case types.VIEW_NOT_EXPECTED: {
      return {
        ...state,
        viewNotExpected: true,
        viewMissing: false,
        selectedMissingTicketNumberId: null,
      };
    }
    case types.SELECT_MISSING_TICKET_NUMBER_ID: {
      const { selectedMissingTicketNumberId } = action;
      return {
        ...state,
        selectedMissingTicketNumberId,
      };
    }
    default:
      return state;
  }
};


export default reducer;
